import type { ReactNode } from 'react';
import { Card } from './Card';

interface ChartCardProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

export function ChartCard({ title, description, actions, children }: ChartCardProps) {
  return (
    <Card className="flex flex-col gap-3">
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-0.5">
          <span className="text-[18px] leading-6 font-semibold text-text-primary">{title}</span>
          {description && <span className="text-[15px] leading-6 text-text-secondary">{description}</span>}
        </div>
        {actions}
      </div>
      {children}
    </Card>
  );
}
